import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router'; 
import { ClientService } from '../../../services/client.service';
import { PetService } from '../../../services/pet.service'; 
import Swal from 'sweetalert2'; 
declare var $: any;

@Component({
  selector: 'ngx-client-note',
  templateUrl: './client-note.component.html' 
})
export class ClientNoteComponent implements OnInit {

  private _client_no: number;
  show_all = false;
  search_typetxtbox: any = ''
  search_wordtxtbox: string = '' 
  
  newNote:{note_sequence:number ,note_text: string, note_type: number} = {note_sequence:0,note_text: '', note_type: 0}
  action_type: number = 0

  //for search items
  snote_type: number = 0
  snote_startDate: string = '' 
  snote_endDate: string = ''

  //use "this.clientService.current_client_no" to get the client_no
  // @Input() set client_no(value: number) {
  //   this._client_no = value;
  // }

  // get client_no(): number {
  //   return this._client_no;
  // }

  constructor(
    public clientService: ClientService,
    public petService: PetService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
      this._client_no = this.clientService.current_client_no

      this.clientService.GetClientNoteType().then(() => {}); 
  
      this.getClientNotes(this._client_no,0,'','')
  }

  add(){
    this.newNote.note_sequence = 0
    this.action_type = 1
    this.newNote.note_text = ''
    this.newNote.note_type = 0

    $('#saveNoteModal').modal('toggle');
  }

  search_click(){
      this.getClientNotes(this._client_no, this.snote_type, this.snote_startDate, this.snote_endDate)
  }

  getClientNotes(client_no, note_type, startDate, endDate){
    this.clientService.GetClientNote(client_no, note_type, startDate, endDate).then(() => {
      this.clientService.client_notes.forEach(element => {
        element.note_date = this.formatDateString(element.note_date)
      })
    }); 
  }

  showAll(){}

  order(no){}

  saveNote(){
    this.clientService.setupClientNote(this.action_type, this.newNote.note_sequence, this._client_no, this.newNote.note_type, this.newNote.note_text).then(() => {
        $('#saveNoteModal').modal('toggle');
        Swal.fire({
            title: 'Success!',
            text: 'Note has been saved',
            icon: 'success',
            confirmButtonText: 'Ok'
        })
        this.getClientNotes(this._client_no,0,'','')
    })
  }

  getNoteTypeDesc(no){
    let toreturn = ''
    if(no == 1){
      toreturn = 'Client Note'
    }
    else if(no == 2){
      toreturn = 'Contact Note'
    }
    else if(no == 3){
      toreturn = 'Family Note'
    }
    else if(no == 4){
      toreturn = 'Part Owner Note'
    }
    else if(no == 5){
      toreturn = 'Patient Related'
    }

    return toreturn
  }

  formatDateString(dateString) {
    // Create a Date object from the input string
    const date = new Date(dateString);
  
    // Extract the month, day, and year
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
  
    // Format the date as MM-dd-YYYY
    return `${month}-${day}-${year}`;
  }
}
